import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  private readonly defaultError = 'Ocorreu um erro desconhecido!';

  constructor(private snackBar: MatSnackBar) {}

  handleHttpError(error: HttpErrorResponse): void {
    const message = error.error instanceof ErrorEvent
      ? `Erro do cliente: ${error.error.message}`
      : error.status
        ? `Erro do servidor: ${error.status} - ${error.message}`
        : this.defaultError;

    this.snackBar.open(message, 'Fechar', { duration: 3000, panelClass: ['snackbar-error'] });
  }

  handleError<T>(error: any, message: string): Observable<T> {
    this.snackBar.open(message, 'Fechar', { duration: 3000, panelClass: ['snackbar-error'] });
    return throwError(() => new Error(message));
  }
}